import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { bankAccountTypesReducer } from './bank-account-types.reducer';
import { BankAccountTypesEffects } from './bank-account-types.effects';
import { STORE_TYPE } from './bank-account-types.model';

@NgModule({
  imports: [
    StoreModule.forFeature(STORE_TYPE, bankAccountTypesReducer),
    EffectsModule.forFeature([BankAccountTypesEffects]),
  ],
})
export class UIBankAccountTypesStoreModule {}